module.exports = __webpack_public_path__ + "static/media/iar_vehicle_fire.e7bb460f.svg";